import Vue from 'vue';
import VuetifyAdmin from '@ilteducation/vuetify-admin';
import '@ilteducation/vuetify-admin/src/loader';
// import { jsonServerDataProvider } from '@ilteducation/vuetify-admin/src/providers';
import { en } from '@ilteducation/vuetify-admin/src/locales';
import axios from 'axios';
import Clipboard from 'v-clipboard';
import VueCroppie from 'vue-croppie';
import { VueQueryPlugin } from '@tanstack/vue-query';
import VueQuillEditor from '../components/article/editor';
import authProvider from '@/data-provider/authProvider';
import interceptorsSetup from '@/foundations/helpers/interceptors';
import customProvider from '../data-provider/customProvider';
import router from '../router';
import routes from '../router/admin';
import store from '../store';
import i18n from '../i18n';
import resources from '../resources';
/* eslint-disable import/no-extraneous-dependencies */
import 'croppie/croppie.css';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

/**
 * Load Admin UI components
 */
Vue.use(VuetifyAdmin);

Vue.use(Clipboard);

Vue.use(VueCroppie);

Vue.use(VueQueryPlugin);

Vue.use(VueQuillEditor);

/**
 * Axios instance
 */
const baseURL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

interceptorsSetup();

const http = axios.create({
  baseURL,
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
});

const dataProvider = customProvider();

/**
 * Init admin
 */
export default new VuetifyAdmin({
  router,
  store,
  i18n,
  title: 'ILT Admin',
  routes,
  locales: {
    en,
  },
  translations: ['en'],
  dataProvider,
  authProvider,
  resources,
  http,
  options: {
    dateFormat: 'long',
  },
});
